"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var typeChecks_1 = require("../utils/typeChecks");
var object_1 = require("../utils/object");
var isArrayLike_1 = require("../utils/isArrayLike");
var isQueryOptionsObject_1 = require("../utils/isQueryOptionsObject");
var PropertyQuery_1 = require("./PropertyQuery");
var AllocationsQuery_1 = require("./AllocationsQuery");
var StatisticsQuery_1 = require("./StatisticsQuery");
var TimeseriesQuery_1 = require("./TimeseriesQuery");
var FundManagerQuery_1 = require("./FundManagerQuery");
var FundManagersQuery_1 = require("./FundManagersQuery");
var CommentaryQuery_1 = require("./CommentaryQuery");
var DisclaimerQuery_1 = require("./DisclaimerQuery");
var DocumentQuery_1 = require("./DocumentQuery");
var ResponseQuery_1 = require("./ResponseQuery");
var ValueQuery_1 = require("./ValueQuery");
var DynamicQuery_1 = require("./DynamicQuery");
var InputQuery_1 = require("./InputQuery");
var StatisticQuery_1 = require("./StatisticQuery");
var ObjectQuery_1 = require("./ObjectQuery");
var GlobalQuery_1 = require("./GlobalQuery");
var FundListsQuery_1 = require("./FundListsQuery");
var ClientConfigurationQuery_1 = require("./ClientConfigurationQuery");
var UrlQuery_1 = require("./UrlQuery");
var ContextStore_1 = require("../stores/ContextStore");
exports.CONTEXT_STORE_WINDOW_KEY = '__ksysContextStore__';
var Query = /** @class */ (function () {
    function Query(options, translationHelper, callStackLevel) {
        this.options = options;
        this.translationHelper = translationHelper;
        this.callStackLevel = callStackLevel;
    }
    Object.defineProperty(Query, "contextStore", {
        get: function () {
            if (!window[exports.CONTEXT_STORE_WINDOW_KEY]) {
                window[exports.CONTEXT_STORE_WINDOW_KEY] = new ContextStore_1.ContextStore();
            }
            return window[exports.CONTEXT_STORE_WINDOW_KEY];
        },
        enumerable: true,
        configurable: true
    });
    Query.getContext = function (executionOptions, queryOptions) {
        if (executionOptions) {
            var context = executionOptions.context;
            if (context) {
                return context;
            }
        }
        if (queryOptions) {
            var defaultContextParentKey = executionOptions.defaultContextParentKey;
            var _a = queryOptions.contextParentKey, contextParentKey = _a === void 0 ? defaultContextParentKey : _a, _b = queryOptions.contextKey, contextKey = _b === void 0 ? 'default' : _b;
            if (Query.contextStore) {
                var contextAndConfiguration = Query.contextStore.get({ contextParentKey: contextParentKey, contextKey: contextKey });
                return contextAndConfiguration && contextAndConfiguration.context;
            }
        }
        return undefined;
    };
    Query.convertQueryKeyValue = function (queryKeyValue, executionOptions, staticOptions) {
        var response = {};
        if (queryKeyValue) {
            Object.keys(queryKeyValue).forEach(function (key) {
                var valueQueryOptions = queryKeyValue[key];
                if (valueQueryOptions) {
                    var valueQuery = new Query(valueQueryOptions, staticOptions && staticOptions.translationHelper);
                    var value = valueQuery.execute(executionOptions);
                    response[key] = value;
                }
            });
        }
        return response;
    };
    Query.convertQueryMime = function (queryMime, executionOptions, staticOptions) {
        var response = {};
        if (typeof queryMime === 'object') {
            var _queryResponseMappings = queryMime._queryResponseMappings;
            var keys = Object.keys(queryMime);
            if (_queryResponseMappings) {
                for (var _i = 0, _a = _queryResponseMappings; _i < _a.length; _i++) {
                    var queryResponseMapping = _a[_i];
                    Query.loadQueryResponseMapping(queryResponseMapping, response, queryMime, executionOptions, keys, staticOptions);
                }
            }
            keys.forEach(function (key) {
                Query.loadQueryMimeKey(response, key, queryMime, executionOptions, staticOptions);
            });
            return response;
        }
        return queryMime;
    };
    Query.loadQueryResponseMapping = function (queryResponseMapping, response, queryMime, executionOptions, keys, staticOptions) {
        var key = queryResponseMapping.key, children = queryResponseMapping.children;
        Query.loadQueryMimeKey(response, key, queryMime, executionOptions, staticOptions);
        var keyIndex = keys.indexOf(key);
        if (keyIndex > -1) {
            keys.splice(keyIndex, 1);
        }
        var parentResponse = response[key];
        if (children && isArrayLike_1.isArrayLike(children) && children.length > 0) {
            for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                var child = children_1[_i];
                Query.loadQueryResponseMapping(child, response, queryMime, __assign(__assign({}, executionOptions), { responseContext: parentResponse }), keys, staticOptions);
            }
        }
    };
    Query.loadQueryMimeKey = function (response, key, queryMime, executionOptions, staticOptions) {
        var value = queryMime[key];
        if (value) {
            if (isArrayLike_1.isArrayLike(value)) {
                response[key] = value.map(function (item) {
                    return Query.convertQueryMime(item, executionOptions, staticOptions);
                });
            }
            else if (typeof value === 'object') {
                if (value.queryOptionsType) {
                    var valueQuery = new Query(value, staticOptions && staticOptions.translationHelper);
                    var responseValue = valueQuery.execute(executionOptions);
                    response[key] = responseValue;
                }
                else {
                    response[key] = Query.convertQueryMime(value, executionOptions, staticOptions);
                }
            }
            else {
                response[key] = value;
            }
        }
    };
    Query.prototype.mergeExecutionOptions = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var response = {};
        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
            var arg = args_1[_a];
            if (arg) {
                var fullContext = arg.context, executionOptions = __rest(arg, ["context"]);
                var _b = (fullContext || {}), entityByType = _b.entityByType, context = __rest(_b, ["entityByType"]);
                var hasContext = typeof context === 'object' && Object.keys(context).length > 0;
                response = object_1.deepMergeObjects(response, executionOptions, hasContext ? { context: context } : {});
                if (entityByType) {
                    if (!response.context) {
                        response.context = {};
                    }
                    response.context.entityByType = entityByType;
                }
            }
        }
        return response;
    };
    Query.prototype.execute = function (executionOptions) {
        // in the case that the QueryOptions passed has already been converted, we will just return it as is.
        if (!isQueryOptionsObject_1.default(this.options)) {
            return this.options;
        }
        var _a = this.options, queryOptionsType = _a.queryOptionsType, value = _a.value, _b = _a.separators, separators = _b === void 0 ? [] : _b, keyQuery = _a.keyQuery, codeQuery = _a.codeQuery;
        if (keyQuery) {
            var query_1 = new Query(keyQuery, this.translationHelper);
            this.options.key = query_1.execute(executionOptions);
        }
        if (codeQuery) {
            var query_2 = new Query(codeQuery, this.translationHelper);
            this.options.code = query_2.execute(executionOptions);
        }
        var query;
        if (!typeChecks_1.isUndefined(value)) {
            query = new ValueQuery_1.ValueQuery(this.options, this.translationHelper);
        }
        else if (queryOptionsType) {
            switch (queryOptionsType) {
                case 'response':
                    query = new ResponseQuery_1.ResponseQuery(this.options, this.translationHelper);
                    break;
                case 'dynamic':
                    query = new DynamicQuery_1.DynamicQuery(this.options, this.translationHelper);
                    break;
                case 'input':
                    query = new InputQuery_1.InputQuery(this.options, this.translationHelper);
                    break;
                case 'property':
                    query = new PropertyQuery_1.PropertyQuery(this.options, this.translationHelper);
                    break;
                case 'allocations':
                    query = new AllocationsQuery_1.AllocationsQuery(this.options, this.translationHelper);
                    break;
                case 'statistics':
                    query = new StatisticsQuery_1.StatisticsQuery(this.options, this.translationHelper);
                    break;
                case 'statistic':
                    query = new StatisticQuery_1.StatisticQuery(this.options, this.translationHelper);
                    break;
                case 'timeseries':
                    query = new TimeseriesQuery_1.TimeseriesQuery(this.options, this.translationHelper);
                    break;
                case 'fundManager':
                    query = new FundManagerQuery_1.FundManagerQuery(this.options, this.translationHelper);
                    break;
                case 'fundManagers':
                    query = new FundManagersQuery_1.FundManagersQuery(this.options, this.translationHelper);
                    break;
                case 'commentaries':
                    query = new CommentaryQuery_1.CommentaryQuery(this.options, this.translationHelper);
                    break;
                case 'disclaimers':
                    query = new DisclaimerQuery_1.DisclaimerQuery(this.options, this.translationHelper);
                    break;
                case 'documents':
                    query = new DocumentQuery_1.DocumentQuery(this.options, this.translationHelper);
                    break;
                case 'fundLists':
                    query = new FundListsQuery_1.FundListsQuery(this.options, this.translationHelper);
                    break;
                case 'object':
                    query = new ObjectQuery_1.ObjectQuery(this.options, this.translationHelper);
                    break;
                case 'global':
                    query = new GlobalQuery_1.GlobalQuery(this.options, this.translationHelper);
                    break;
                case 'clientConfiguration':
                    query = new ClientConfigurationQuery_1.ClientConfigurationQuery(this.options, this.translationHelper);
                    break;
                case 'url':
                    query = new UrlQuery_1.UrlQuery(this.options, this.translationHelper);
                    break;
            }
        }
        if (query) {
            var queryResponse = query.execute(executionOptions, this.callStackLevel);
            if (queryResponse && typeof queryResponse === 'string' && separators && separators.length > 0) {
                queryResponse = this.stripWrappingSeparators(queryResponse, separators);
            }
            return queryResponse;
        }
    };
    Query.prototype.stripWrappingSeparators = function (queryResponse, separators) {
        for (var separatorIndex = 0; separatorIndex < separators.length; separatorIndex++) {
            var separator = separators[separatorIndex];
            var separtorLength = separator.length;
            while (queryResponse.startsWith(separator)) {
                queryResponse = queryResponse.substr(separtorLength);
            }
            while (queryResponse.endsWith(separator)) {
                queryResponse = queryResponse.substr(0, queryResponse.length - separtorLength);
            }
        }
        return queryResponse;
    };
    return Query;
}());
exports.Query = Query;
//# sourceMappingURL=Query.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/Query.js
// module id = 23
// module chunks = 1